import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ReactDOM from 'react-dom';
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const getItemStyle = (isDragging, draggableStyle) => (Object.assign({ 
    // some basic styles to make the items look a bit nicer
    userSelect: 'none', padding: 0, margin: 0 }, draggableStyle));
const getListStyle = (isDraggingOver, readOnly) => ({
    padding: '5px 0px',
    cursor: readOnly ? 'default' : undefined,
});
const DraggableList = (props) => {
    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const items = reorder(props.list, result.source.index, result.destination.index);
        props.onChange(items);
    };
    return (React.createElement("div", null, 
    // @ts-ignore
    React.createElement(DragDropContext, { onDragEnd: onDragEnd },
        React.createElement(Droppable, { droppableId: "droppable" }, (provided, snapshot) => (React.createElement("div", Object.assign({}, provided.droppableProps, { ref: provided.innerRef, style: getListStyle(snapshot.isDraggingOver, props.readOnly) }),
            props.list.map((item, index) => (React.createElement(Draggable, { key: item.id, draggableId: item.id, index: index, isDragDisabled: props.readOnly }, (provided, snapshot) => (
            // @ts-ignore
            React.createElement(DraggablePortal, { provided: provided, snapshot: snapshot, item: item }, item.content))))),
            provided.placeholder))))));
};
const DraggablePortal = (props) => {
    const { provided, snapshot, item } = props;
    const content = (React.createElement("div", Object.assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { style: getItemStyle(snapshot.isDragging, provided.draggableProps.style) }), item.content));
    if (snapshot.isDragging)
        return ReactDOM.createPortal(content, document.body);
    return content;
};
export default DraggableList;
//# sourceMappingURL=DraggableList.js.map